import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFirebaseAuth } from '../context/FirebaseAuthContext';
import { useApp } from '../context/useApp';

const ProtectedRoute = ({ children }) => {
  const { user: currentUser, loading } = useFirebaseAuth();
  
  // Also check AppContext for authentication state
  let appContextAuthenticated = false;
  try {
    const appContext = useApp();
    if (appContext) {
      appContextAuthenticated = appContext.isAuthenticated || false;
    }
  } catch (error) {
    console.log('AppContext not available in ProtectedRoute:', error.message);
  }

  // Show loading while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-primary">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  // Check both SupabaseAuthContext and AppContext for authentication
  const isAuthenticated = currentUser || appContextAuthenticated;
  
  console.log('ProtectedRoute - Auth state:', {
    currentUser: !!currentUser,
    appContextAuthenticated,
    isAuthenticated,
    loading
  });
  
  // Redirect to auth if not logged in
  if (!isAuthenticated) {
    console.log('ProtectedRoute - Redirecting to /auth');
    return <Navigate to="/auth" replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
